module.exports = __webpack_public_path__ + "img/art_7_3.02a4b8a9.png";